import { useEffect, useRef, useState } from "react";

/* Scroll-triggered entrance. IntersectionObserver + a CSS transition rather
   than another animation dependency - animate.css is already carrying the
   section fades, and this needs per-item stagger that it can't express.

   Fires once: re-animating a card every time it scrolls back past is the
   thing that makes portfolio sites feel twitchy. */
export const Reveal = ({
  children,
  className = "",
  variant = "up",
  delay = 0,
  threshold = 0.15,
}) => {
  const ref = useRef(null);
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setRevealed(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        setRevealed(true);
        observer.disconnect();
      },
      { threshold, rootMargin: "0px 0px -60px 0px" }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [threshold]);

  return (
    <div
      ref={ref}
      className={`reveal reveal-${variant} ${revealed ? "is-revealed" : ""} ${className}`}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
    >
      {children}
    </div>
  );
};
